import React from 'react';
import { Link } from 'react-router-dom';
import './StateGrid.css';

export default function StateGrid({ states }) {
    // Helper to get initials for the icon
    const getInitials = (name) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .substring(0, 2)
            .toUpperCase();
    };

    return (
        <section className="state-section">
            <div className="state-container">
                <div className="section-header">
                    <h2 className="section-title">Browse by State</h2>
                    <p className="section-subtitle">Explore businesses and services across India's states and territories</p>
                </div>

                <div className="state-grid">
                    {states.map((state) => (
                        <Link key={state.id} to={`/in/${state.slug}`} className="state-card">
                            <div className="state-info">
                                <div className="state-icon">
                                    {getInitials(state.name)}
                                </div>
                                <span className="state-name">{state.name}</span>
                            </div>
                            <svg
                                className="state-arrow"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
